module.exports = __webpack_public_path__ + "media/MAIN_FILM_V05.afd12005.mp4";